var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audit-list-expand"},[_c('div',[_c('b',[_vm._v(_vm._s(_vm.$t('audit.comments'))+":")])]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.data.comments)}})])}
var staticRenderFns = []

export { render, staticRenderFns }